import React from "react";

import { PropsTypeSvg } from "@typings/global.types";

function CharactersSvg({ classNameProps, height, width }: PropsTypeSvg) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      className={classNameProps}
      width={width}
      height={height}
      fill='none'
    >
      <ellipse opacity='.1' cx='18.5' cy='21' rx='18.5' ry='1' fill='#333' />
      <rect
        x='34.22'
        y='6.137'
        width='5.298'
        height='6.96'
        rx='2.649'
        transform='rotate(25.562 34.22 6.137)'
        fill='#EB84AF'
      />
      <circle cx='25.09' cy='16.506' r='4.226' fill='#F69EC4' />
      <circle cx='19.808' cy='17.562' r='3.169' fill='#F69EC4' />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M38.462 14.593l-5.75.404 5.75.261c-.178 3.052-2.747 5.473-5.89 5.473-3.257 0-5.898-2.602-5.898-5.81 0-3.21 2.641-5.811 5.899-5.811 3.146 0 5.717 2.426 5.889 5.483z'
        fill='#F69EC4'
      />
      <rect
        x='28.525'
        y='7.667'
        width='6.166'
        height='7.955'
        rx='3.083'
        transform='rotate(-15.689 28.525 7.667)'
        fill='#F69EC4'
      />
      <circle
        cx='32.355'
        cy='9.636'
        r='2.025'
        transform='rotate(.039 32.355 9.636)'
        fill='#fff'
      />
      <circle
        cx='32.88'
        cy='9.636'
        r='1.229'
        transform='rotate(.039 32.88 9.636)'
        fill='#000'
      />
      <rect
        width='6.836'
        height='10.222'
        rx='3.418'
        transform='matrix(.90294 .42976 -.43323 .90129 21.413 0)'
        fill='#5A8E26'
      />
      <path
        d='M12.467 17.897l1.476-2.177 2.36 1.185a6.314 6.314 0 01-3.782.995l-.054-.003zM19.68 18.792l2.408 1.642c.115.079.03.257-.103.22a.529.529 0 00-.642.34.213.213 0 01-.31.116l-.077-.046a.709.709 0 00-.848.091l-.034.032a.257.257 0 01-.403-.068l-.826-1.586a.576.576 0 01.836-.741z'
        fill='#6CA732'
      />
      <path
        d='M13.435 17.676l3.804 1.726c.182.082.107.354-.09.334a.756.756 0 00-.822.639.305.305 0 01-.41.239l-.118-.046a1.015 1.015 0 00-1.174.338l-.04.053a.367.367 0 01-.586.003l-1.559-2.035a.824.824 0 01.995-1.251z'
        fill='#6CA732'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M27.421 11.207H20.63l6.773.816c-.294 3.946-3.512 7.054-7.437 7.054-4.12 0-7.46-3.423-7.46-7.645 0-4.222 3.34-7.644 7.46-7.644 4.046 0 7.34 3.301 7.455 7.42z'
        fill='#79BB38'
      />
      <rect
        width='6.776'
        height='9.757'
        rx='3.388'
        transform='rotate(-15.611 15.172 -56.09) skewX(.157)'
        fill='#79BA38'
      />
      <ellipse
        rx='1.717'
        ry='1.721'
        transform='matrix(.55317 -.83307 .83573 .54914 16.26 8.841)'
        fill='#68A42D'
      />
      <ellipse
        rx='.938'
        ry='.94'
        transform='matrix(.55317 -.83307 .83573 .54914 14.235 11.585)'
        fill='#68A42D'
      />
      <ellipse
        rx='.668'
        ry='.669'
        transform='matrix(.55317 -.83307 .83573 .54914 16.346 11.74)'
        fill='#68A42D'
      />
      <circle cx='19.758' cy='4.315' r='1.925' fill='#fff' />
      <circle cx='20.177' cy='4.399' r='1.172' fill='#000' />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M1.004 14.134A7.25 7.25 0 011 13.858c0-4.037 3.358-7.31 7.5-7.31 4.143 0 7.501 3.273 7.501 7.31 0 4.038-3.358 7.31-7.5 7.31-3.753 0-6.861-2.685-7.414-6.191l7.02-.534-7.102-.309z'
        fill='#FFDA56'
      />
      <circle r='1.658' transform='matrix(-1 0 0 1 8.816 10.89)' fill='#fff' />
      <circle r='1.009' transform='matrix(-1 0 0 1 8.455 10.962)' fill='#000' />
    </svg>
  );
}

export default CharactersSvg;
